import { RadioButtonProps } from "./InputProps";

import "./RadioButton.scss";

const RadioButton: React.FC<RadioButtonProps> = ({ checked, name, handleFieldChange, field }) => {
    return (
        <div className="fee-calc-radio">
            <input
                type="radio"
                id={`${name}_${field.id}`}
                name={name}
                value={field.id}
                checked={checked}
                onChange={() => handleFieldChange(field.id)}
                required
            />
            <label htmlFor={`${name}_${field.id}`}>
                {field.label} {field.subLabel && <em>({field.subLabel})</em>}
            </label>
        </div>
    );
};

export default RadioButton;
